import {
  Component,
  Inject,
  OnDestroy,
  OnInit,
  Optional,
  PLATFORM_ID,
} from '@angular/core';
import { WaterBodyDAO } from '../../../../core/services/dao/waterBodyDAO';
import { WaterBody } from 'anchor-shared/lib/model/entity/waterBody';
import { FullWidthBannerConfig } from '../../../../core/models/interface/full-width-banner-config';
import { Category } from 'anchor-shared/lib/model/enum/vessel-category-types';
import { ActivatedRoute, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { BuyflowVesselSortType } from 'anchor-shared/lib/model/enum/buyflow-vessel-sort-type';
import {
  BUYFLOW_LENGTH_MAX,
  BUYFLOW_PRICE_MAX,
  BuyflowConfigLimits,
  BuyflowVesselSortConfig,
} from '../../../shared/buyflow-sort-filter-control/buyflow-sort-filter-control.component';
import * as moment from 'moment';
import { Moment } from 'moment';
import { DialogsService } from '../../../../core/services/dialog.service';
import { BuyflowSortFilterService } from '../../../../core/services/buyflow-sort-filter.service';
import { AppLocation } from '../../../../core/models/interface/geo';
import { DOCUMENT, isPlatformBrowser, isPlatformServer } from '@angular/common';
import {
  DomSanitizer,
  makeStateKey,
  Meta,
  SafeHtml,
  Title,
  TransferState,
} from '@angular/platform-browser';
import {
  defaultMetaImage,
  getLocationDescription,
  getLocationTitle,
} from '../../../../core/pure-functions/upload/ng-universal-tags';
import { getExtension } from '../../../../core/pure-functions/upload/image-upload-helper';
import {
  BUYFLOW_MAP_MIN,
  BuyflowMapInitialization,
  buyflowMapZoomIsValid,
  MapBoundsAndZoom,
} from '../../../shared/app-buyflow-map/app-buyflow-map.component';
import { unsubscribeFromAll } from '../../../../core/pure-functions/rx-helper';
import { ContainsSubscriptions } from '../../../../core/services/interfaces/contains-subscriptions';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { UserAgentDetection } from '../../../../core/pure-functions/universal/user-agent-detection';
import { REQUEST } from '@nguniversal/express-engine/tokens';
import { Request } from 'express';
import { ConstantMan } from '../../../../core/services/constantMan';
import { EnvironmentalMediaService } from '../../../../core/services/environmental-media.service';
import { decreaseLatLongPrecision } from '../../../../core/pure-functions/geo/lat-long-precision/lat-long-precision-util';
import { calculateMapBoundsFromCenterPoint } from '../../../../core/pure-functions/map-bounds/calc-map-bounds-from-center-point/calculate-map-bounds-from-center-point';
import { dateSessionStorageFormat } from '../../../buyflow-home/buyflow-home.component';
import { VesselAvailabilityDAO } from '../../../../core/services/dao/VesselAvailabilityDAO';
import ZoomControlOptions = google.maps.ZoomControlOptions;
import { MobileSortConfig } from '../../buyflow-sort-filter-dialog/buyflow-sort-filter-dialog.component';
import { Vessel } from 'anchor-shared/lib/model/entity/vessel';
import { CharterType } from 'anchor-shared/lib/model/enum/charter-type';
import { CustomerReviewDAO } from '../../../../core/services/dao/customerReviewDAO';

const CHARTER_BUYFLOW_WATER_BODIES_KEY = makeStateKey(
  'charterBuyflowWaterBodies',
);

@Component({
  selector: 'app-charter-buyflow-vessels',
  templateUrl: './charter-buyflow-vessels.component.html',
  styleUrls: ['./charter-buyflow-vessels.component.scss'],
})
export class CharterBuyflowVesselsComponent
  implements OnInit, OnDestroy, ContainsSubscriptions
{
  subs: Subscription[] = [];
  image: string;
  header: string;
  fullWidthBannerConfig: FullWidthBannerConfig;
  waterBody: WaterBody;
  vessels: Vessel[] = [];
  cachedVessels: Vessel[] = [];
  sortType: BuyflowVesselSortType;
  filterLimits2: BuyflowConfigLimits;
  filteredAndSortedVessels: Vessel[] = [];
  isMobile: boolean;
  showFilters: boolean;
  mobileSortMemory: string[];
  location: AppLocation;
  selectedWaterBody: WaterBody;
  selectableWaterBodies: WaterBody[];
  showMap = false;
  availableOn: Moment;
  availableFrom: Moment;
  availableTo: Moment;
  zoomControlOptions: ZoomControlOptions = {
    position: 6,
  };
  currentFilter: BuyflowVesselSortConfig = null;
  isBrowser: boolean;
  buyflowData: WaterBody[];
  updateVesselSubject: BehaviorSubject<{
    vessels: Vessel[];
  }> = new BehaviorSubject(null);
  updateMapBounds: BehaviorSubject<MapBoundsAndZoom> = new BehaviorSubject(
    null,
  );
  boundedAndFiltered: BehaviorSubject<{
    vessels: Vessel[];
  }> = new BehaviorSubject(null);
  boundsAndZoom: MapBoundsAndZoom;
  buyflowMapInitialization: BuyflowMapInitialization;
  vesselsLoaded = false;
  searchLocation: string = null;
  loading: boolean;
  loadingVessels: boolean = false;
  allVesselsLoaded: boolean = false;
  skeletonItems: number[];
  waterBodyDisplayName: string;
  waterBodyDisplayCity: string;
  pageOffset: number = 0;
  count: number;
  reviewCounts: { [key: string]: number } = {};
  vesselSortOrder: string[] = ConstantMan.VESSEL_SORT_ORDER.PRICE_ASC;
  searchFilters: string[] = [];
  charterType: CharterType = CharterType.DayCharter;
  CharterType = CharterType;

  private itemsPerPage: number = 10;
  safeSeoHtml: SafeHtml;
  safeGoogleBusinessIframe: SafeHtml;
  routeShouldDisplayMeta = true;

  constructor(
    private vesselAvailabilityDao: VesselAvailabilityDAO,
    public route: ActivatedRoute,
    private dialogsService: DialogsService,
    private buyflowSortFilterService: BuyflowSortFilterService,
    private router: Router,
    private waterBodyDAO: WaterBodyDAO,
    private customerReviewDAO: CustomerReviewDAO,
    @Optional() @Inject(REQUEST) private request: Request,
    @Inject(PLATFORM_ID) private platformId: any,
    private title: Title,
    private meta: Meta,
    private environmentalMediaService: EnvironmentalMediaService,
    @Inject(DOCUMENT) private document: any,
    private state: TransferState,
    private sanitizer: DomSanitizer,
  ) {
    this.isBrowser = isPlatformBrowser(this.platformId);
    this.setFilterLimits();
    this.skeletonItems = [1, 2, 3, 4];

    if (isPlatformServer(this.platformId)) {
      if (
        UserAgentDetection.isMobileUserAgent(this.request.headers['user-agent'])
      ) {
        this.isMobile = true;
      }
    } else {
      this.isMobile = window && window.screen && window.screen.width < 960;
    }

    this.location = {
      position: {
        lat: 27.964157,
        lng: -82.452606,
      },
      addressComponents: [],
      formattedAddress: '',
      vicinity: '',
      markerLatitude: 0,
      markerLongitude: 0,
      zoom: 0,
    };
    this.readFilterDateFromStorage();
  }

  ngOnInit() {
    let activeWb: WaterBody;

    this.buyflowData =
      this.route.snapshot.data.buyflowData ??
      this.route.snapshot.data.resolvedData;

    if (window.location.href.includes('rental-location-map')) {
      this.routeShouldDisplayMeta = false;
    }

    this.selectableWaterBodies = this.buyflowData;
    this.searchLocation = this.route.snapshot.params['waterBodyName'];
    this.charterType =
      CharterType[this.route.snapshot.queryParamMap.get('charterType')] ||
      this.charterType;

    if (this.buyflowData && this.buyflowData.length) {
      activeWb = this.selectableWaterBodies.find((wb) => {
        return (
          wb.vanityUrl.toLowerCase() ===
          this.route.snapshot.params['waterBodyName'].toLowerCase()
        );
      });
      if (activeWb) {
        this.waterBody = this.buyflowData.filter(
          (a) => a.id === activeWb.id,
        )[0];
      } else {
        this.waterBody = null;
      }

      if (this.waterBody?.seoContent) {
        this.safeSeoHtml = this.sanitizer.bypassSecurityTrustHtml(
          this.waterBody.seoContent,
        );
      }

      if (this.waterBody?.googleBusinessIframe) {
        // to style the iframe directly we would need to set the view encapsulation to none, which makes
        // the page look terrible. So I decided to do this instead
        this.waterBody.googleBusinessIframe =
          this.waterBody.googleBusinessIframe.replace(
            'width="600"',
            'width="300"',
          );
        this.waterBody.googleBusinessIframe =
          this.waterBody.googleBusinessIframe.replace(
            'height="450"',
            'height="300"',
          );

        this.safeGoogleBusinessIframe = this.sanitizer.bypassSecurityTrustHtml(
          this.waterBody.googleBusinessIframe,
        );
      }

      if (
        (activeWb && !this.route.snapshot.queryParamMap.get('latitude')) ||
        (activeWb && this.route.snapshot.queryParamMap.get('fromSearchBar'))
      ) {
        this.buyflowMapInitialization = this.readLatLongQueryParams(
          this.waterBody,
        );
      } else if (this.route.snapshot.queryParamMap.get('latitude')) {
        this.buyflowMapInitialization = this.readLatLongQueryParams();
      }
    } else {
      if (this.route.snapshot.queryParamMap.get('latitude')) {
        this.buyflowMapInitialization = this.readLatLongQueryParams();
      }
    }

    if (!this.buyflowMapInitialization) {
      this.buyflowMapInitialization = {
        zoom: 11,
        center: {
          latitude: this.location.position.lat,
          longitude: this.location.position.lng,
        },
      };
    }

    if (!activeWb) {
      this.fullWidthBannerConfig = {
        image: defaultMetaImage,
        header: 'Yacht and Boat Rentals in',
        telLink: '8139066064',
        phoneNumber: '813-906-6064',
        subtext: 'Questions? Contact us: ',
        boldTextAppendedToHeader: this.searchLocation,
        emailLink: 'charters@anchorrides.com',
      };
    } else {
      const routeParamSub = this.route.params.subscribe((params) => {
        this.sortType = this.waterBody.buyflowSortType;

        this.fullWidthBannerConfig = {
          image: this.waterBody.headerImagePhotoPath,
          header: 'Yacht and Boat Rentals in',
          telLink: '8139066064',
          phoneNumber: '813-906-6064',
          subtext: 'Questions? Contact us: ',
          boldTextAppendedToHeader: this.waterBody.displayName,
          emailLink: 'charters@anchorrides.com',
        };
      });
      this.subs.push(routeParamSub);
    }
    const filterSub = this.buyflowSortFilterService
      .getBuyflowFilter()
      .subscribe((data) => {
        if (!this.loading && this.currentFilter) {
          this.resetSearch();
          this.filterChange();
        }
        this.currentFilter = data;
        if (!this.currentFilter) {
          // Filters do not get set on mobile until the filters dialog is opened,
          // Setting them here for initial load on mobile
          this.currentFilter = {
            bathrooms: 0,
            boatLengthMax: 500,
            boatLengthMin: 0,
            cabins: 0,
            passengers: 0,
            priceMax: 200000,
            priceMin: 0,
            showers: 0,
            sleeps: 0,
            availableOn: null,
            categories: [],
          };
          this.buyflowSortFilterService
            .getBuyflowFilter()
            .next(this.currentFilter);
        }
      });

    this.subs.push(filterSub);

    this.showFilters = true;
    this.initWatchers();
    const canonical =
      this.environmentalMediaService.getClientBaseURL() +
      'charters/yacht-and-boat-rentals/' +
      this.searchLocation;
    if (window.location.href.includes('charters/')) {
      this.setTags(
        activeWb && activeWb.displayName
          ? activeWb.displayName
          : this.searchLocation,
        activeWb && activeWb.displayState ? activeWb.displayState : '',
        activeWb && activeWb.metaImagePath
          ? activeWb.metaImagePath
          : defaultMetaImage,
        canonical,
        activeWb?.pageTitle ? activeWb.pageTitle : null,
        activeWb?.metaTitle ? activeWb.metaTitle : null,
        activeWb?.metaDescription ? activeWb.metaDescription : null,
      );
      if (activeWb) {
        this.updateCanonical(canonical);
      }
    }

    this.waterBodyDisplayName = this.waterBody
      ? this.waterBody.displayName
      : this.searchLocation.length > 1
      ? this.searchLocation[0].toUpperCase() + this.searchLocation.slice(1)
      : this.searchLocation[0].toUpperCase();

    this.waterBodyDisplayCity = this.waterBody
      ? this.waterBody.displayCity
      : this.searchLocation.length > 1
      ? this.searchLocation[0].toUpperCase() + this.searchLocation.slice(1)
      : this.searchLocation[0].toUpperCase();

    this.removeTransferState();
    if (this.isMobile) {
      this.setFiltersFromQueryParams();
    }
  }

  setVanityURL(activeWb) {
    if (
      !this.route.snapshot.queryParamMap.get('latitude') ||
      !this.route.snapshot.queryParamMap.get('longitude')
    ) {
      this.router.navigate(['rental-location-map', activeWb.vanityUrl], {
        queryParams: {
          latitude: activeWb.latitude,
          longitude: activeWb.longitude,
          zoom: activeWb.zoom,
          maxZoom: activeWb.maxZoom,
          date: this.availableOn?.format('YYYY-MM-DD'),
        },
        queryParamsHandling: 'merge',
      });
    }
  }

  resetSearch() {
    this.loading = true;
    this.vessels = [];
    this.cachedVessels = [];
    this.filteredAndSortedVessels = [];
    this.pageOffset = 0;
    this.allVesselsLoaded = false;
    this.vesselsLoaded = false;
    this.loadingVessels = true;
  }

  dateChangeEvent(event: any) {
    this.currentFilter.availableOn = this.availableOn;
  }

  onUpdateTypeChange(type: CharterType) {
    this.resetSearch();
    this.charterType = type;

    this.onUpdateBoundsEvent(this.boundsAndZoom);
  }

  showMapClick(isMobile?: boolean): void {
    if (isMobile) {
      this.buyflowMapInitialization = this.readLatLongQueryParams(
        this.waterBody,
      );
      const sub = this.dialogsService
        .BuyflowMapDialog(
          this.filteredAndSortedVessels,
          this.location,
          this.updateMapBounds,
          this.boundedAndFiltered,
          this.buyflowMapInitialization,
        )
        .subscribe((data) => {});
      this.subs.push(sub);
    } else {
      this.showMap = !this.showMap;
    }
  }

  mobileFilterClick(): void {
    const sub = this.dialogsService
      .BuyflowSortFilterDialog(
        this.filterLimits2,
        this.currentFilter,
        this.mobileSortMemory,
        this.availableOn,
      )
      .subscribe((mobileFilterData) => {
        if (mobileFilterData) {
          this.initiateMobileFiltering(mobileFilterData);
        }
      });
    this.subs.push(sub);
  }

  initiateMobileFiltering(mobileFilterData: MobileSortConfig) {
    if (mobileFilterData.filters && mobileFilterData.sort) {
      this.mobileSortMemory = mobileFilterData.sort;
      this.vesselSortOrder = mobileFilterData.sort;
      this.buyflowSortFilterService
        .getBuyflowFilter()
        .next(mobileFilterData.filters);
    } else if (mobileFilterData.sort) {
      this.sortChange(mobileFilterData.sort);
    } else if (mobileFilterData.filters) {
      this.buyflowSortFilterService
        .getBuyflowFilter()
        .next(mobileFilterData.filters);
    }

    if (mobileFilterData.clearClick) {
      const queryParams = {};

      queryParams['priceMin'] = 0;
      sessionStorage.setItem('priceMin', '0');

      queryParams['priceMax'] = 200000;
      sessionStorage.setItem('priceMax', '200000');

      queryParams['passengers'] = 0;
      sessionStorage.setItem('passengers', '0');

      queryParams['boatLengthMin'] = 0;
      sessionStorage.setItem('boatLengthMin', '0');

      queryParams['boatLengthMax'] = 500;
      sessionStorage.setItem('boatLengthMax', '500');

      queryParams['categories'] = JSON.stringify([]);
      sessionStorage.setItem('categories', JSON.stringify([]));

      this.router.navigate([], {
        relativeTo: this.route,
        queryParams: queryParams,
        queryParamsHandling: 'merge',
      });
      this.buyflowSortFilterService.resetBuyflowFilter();
    }
  }

  sortChange(sortType: string[]): void {
    this.mobileSortMemory = sortType;
    this.vesselSortOrder = sortType;
    this.resetSearch();
    this.onUpdateBoundsEvent(this.boundsAndZoom);
  }

  autocompleteSearchAddress(location: AppLocation) {
    if (
      this.location.addressComponents &&
      this.location.addressComponents.length > 0
    ) {
      this.location = location;
      // send request to API to calculate which waterbody to filter
      const sub = this.waterBodyDAO
        .findClosestWaterBodyToPlacesInput(this.location)
        .subscribe((waterBodyVanityURL) => {
          const route = 'rental-location-map/' + waterBodyVanityURL;
          this.router.navigate([route]).then(() => {
            this.buyflowSortFilterService.resetBuyflowFilter();
          });
        });
      this.subs.push(sub);
    }
  }

  filterChange(): void {
    this.onUpdateBoundsEvent(this.boundsAndZoom);
  }

  dateFilter = (incomingMoment: Moment): boolean => {
    if (incomingMoment.isSame(moment(), 'day')) {
      return true;
    }
    if (incomingMoment.isBefore(moment())) {
      return false;
    }
    return true;
  };

  ngOnDestroy(): void {
    unsubscribeFromAll(this.subs);
  }

  onDateChange(boundsAndZoom: MapBoundsAndZoom): void {
    this.resetSearch();
    this.onUpdateBoundsEvent(boundsAndZoom);
  }

  onUpdateBoundsEvent(boundsAndZoom: MapBoundsAndZoom): void {
    if (!this.isBrowser) {
      return;
    }
    if (this.vessels.length > 0 && this.cachedVessels.length > 0) {
      this.vessels.push(...this.cachedVessels);
    }

    if (
      (!boundsAndZoom && this.isBrowser) ||
      (boundsAndZoom && !boundsAndZoom.mapBounds)
    ) {
      boundsAndZoom = this.getBoundsAndZoomWhenNull();
    }

    this.boundsAndZoom = boundsAndZoom;
    this.readFilterDateFromStorage();
    this.decreaseBoundsPrecision(boundsAndZoom);
    const { mapBounds, zoom, center } = boundsAndZoom;
    const vesselUpdateSub = this.vesselAvailabilityDao
      .getVesselsForMap(
        mapBounds,
        this.pageOffset,
        this.itemsPerPage,
        this.charterType,
        JSON.stringify(
          this.buyflowSortFilterService.getBuyflowFilter().getValue(),
        ),
        JSON.stringify(this.vesselSortOrder),
        this.charterType === CharterType.DayCharter
          ? this.availableOn
          : this.availableFrom,
        this.availableTo,
      )
      .subscribe((res: { count: number; rows: Vessel[]; page?: number }) => {
        if (res.page) {
          this.pageOffset = res.page;
        } else {
          this.pageOffset++;
        }
        this.count = res.count;

        if (res.rows.length === 0) {
          this.allVesselsLoaded = true;
          this.loadingVessels = false;
        }
        if (!this.vessels.length) {
          this.vessels.push(...res.rows);
          this.loading = false;
        } else {
          this.cachedVessels = res.rows;
        }
        const vesselIds = res.rows.map((x: any) => x.vesselId);
        // in an effort to not slow down page load, get review count
        const reviewCountSub = this.customerReviewDAO
          .getReviewCounts(vesselIds)
          .subscribe((reviewCounts) => {
            this.reviewCounts = { ...this.reviewCounts, ...reviewCounts };
          });
        this.subs.push(reviewCountSub);

        this.filteredAndSortedVessels = this.vessels;
        this.filteredAndSortedVessels.forEach((vessel) => {
          // @ts-ignore
          if (typeof vessel?.parkingAddressComponents === String) {
            vessel['parkingAddressComponents'] = JSON.parse(
              vessel['parkingAddressComponents'],
            );
          }
        });

        this.updateVesselSubject.next({ vessels: this.vessels });
        this.boundedAndFiltered.next({
          vessels: this.filteredAndSortedVessels,
        });

        if (!this.cachedVessels.length && !this.allVesselsLoaded) {
          this.onUpdateBoundsEvent(this.boundsAndZoom);
          this.loadingVessels = true;
        } else {
          this.loadingVessels = false;
        }

        this.vesselsLoaded = true;

        this.router
          .navigate([], {
            relativeTo: this.route,
            queryParams: {
              latitude: center.latitude,
              longitude: center.longitude,
              zoom: zoom,
              date: this.availableOn?.format('YYYY-MM-DD'),
              fromSearchBar: null,
            },
            queryParamsHandling: 'merge',
            replaceUrl: true,
          })
          .catch((mergeQueryParamError) => {
            console.error(mergeQueryParamError);
          });
      });
    this.subs.push(vesselUpdateSub);
  }

  loadMoreData() {
    if (!this.loadingVessels) {
      this.onUpdateBoundsEvent(this.boundsAndZoom);
      this.loadingVessels = true;
    }
  }

  handleBoundsUpdate(e) {
    this.resetSearch();
    this.onUpdateBoundsEvent(e);
  }

  private readLatLongQueryParams(waterBody?): BuyflowMapInitialization {
    if (
      (waterBody && !this.route.snapshot.queryParamMap.get('latitude')) ||
      (waterBody && this.route.snapshot.queryParamMap.get('fromSearchBar'))
    ) {
      const wbLatLongZoom = {
        center: {
          latitude: waterBody.latitude,
          longitude: waterBody.longitude,
        },
        zoom: waterBody.zoom,
      };
      return wbLatLongZoom;
    } else if (this.route.snapshot.queryParamMap.get('latitude')) {
      const latLongZoom = {
        center: {
          latitude: parseFloat(
            this.route.snapshot.queryParamMap.get('latitude'),
          ),
          longitude: parseFloat(
            this.route.snapshot.queryParamMap.get('longitude'),
          ),
        },
        zoom: parseFloat(this.route.snapshot.queryParamMap.get('zoom')),
      };
      if (!buyflowMapZoomIsValid(latLongZoom.zoom)) {
        latLongZoom.zoom = BUYFLOW_MAP_MIN;
        if (
          this.route.snapshot.queryParamMap.get('maxZoom') &&
          parseInt(this.route.snapshot.queryParamMap.get('maxZoom')) !== 0
        ) {
          latLongZoom.zoom = parseInt(
            this.route.snapshot.queryParamMap.get('zoom'),
          );
        }
      }
      return latLongZoom;
    } else {
      return null;
    }
  }

  private initWatchers(): void {
    const sub = this.updateMapBounds.subscribe((bounds) => {
      if (bounds) {
        this.onUpdateBoundsEvent(bounds);
      }
    });
    this.subs.push(sub);
  }

  private setTags(
    waterBodyName: string,
    waterBodyState: string,
    waterBodyImage: string,
    pageUrl: string,
    pageTitle: string,
    metaTitle: string,
    metaDescription: string,
  ): void {
    this.meta.removeTag("name='description'");
    this.title.setTitle(getLocationTitle(waterBodyName, pageTitle));
    this.meta.addTag({
      property: 'title',
      content: getLocationTitle(waterBodyName, metaTitle),
    });
    this.meta.addTag({
      property: 'description',
      content: getLocationDescription(
        waterBodyName,
        waterBodyState,
        metaDescription,
      ),
    });

    // twitter
    this.meta.addTag({
      property: 'twitter:card',
      content: 'summary_large_image',
    });
    this.meta.addTag({
      property: 'twitter:title',
      content: getLocationTitle(waterBodyName, pageTitle),
    });
    this.meta.addTag({
      property: 'twitter:description',
      content: getLocationDescription(
        waterBodyName,
        waterBodyState,
        metaDescription,
      ),
    });
    this.meta.addTag({
      property: 'twitter:image',
      content: waterBodyImage,
    });

    // object graph
    this.meta.addTag({
      property: 'og:site_name',
      content: 'Anchor',
    });
    this.meta.addTag({
      property: 'og:locale',
      content: 'en_US',
    });
    this.meta.addTag({
      property: 'og:title',
      content: getLocationTitle(waterBodyName, pageTitle),
    });
    this.meta.addTag({
      property: 'og:type',
      content: 'anchor:project',
    });
    this.meta.addTag({
      property: 'og:description',
      content: getLocationDescription(
        waterBodyName,
        waterBodyState,
        metaDescription,
      ),
    });
    this.meta.addTag({
      property: 'og:url',
      content: pageUrl,
    });
    this.meta.addTag({
      property: 'og:image',
      content: waterBodyImage,
    });
    this.meta.addTag({
      property: 'og:image:type',
      content: 'image/' + getExtension(waterBodyImage),
    });
  }

  nearestWaterBodyFound($event: WaterBody) {
    this.selectedWaterBody = $event;
    const mapInit: BuyflowMapInitialization = {
      zoom: 15,
      center: {
        latitude: this.selectedWaterBody.latitude,
        longitude: this.selectedWaterBody.longitude,
      },
    };
    this.buyflowMapInitialization = mapInit;
  }

  private setFilterLimits(): void {
    this.filterLimits2 = {
      halfDayMaxPrice: BUYFLOW_PRICE_MAX,
      halfDayMinPrice: 0,
      maxBathrooms: 8,
      maxBoatLength: BUYFLOW_LENGTH_MAX,
      maxCabins: 8,
      maxPassengers: 13,
      maxShowers: 8,
      maxSleeps: 24,
      minBathrooms: 0,
      minBoatLength: 0,
      minCabins: 0,
      minPassengers: 0,
      minShowers: 0,
      minSleeps: 0,
    };
  }

  private updateCanonical(url: string): void {
    const head = this.document.getElementsByTagName('head')[0];
    let element: HTMLLinkElement =
      this.document.querySelector(`link[rel='canonical']`) || null;
    if (element == null) {
      element = this.document.createElement('link') as HTMLLinkElement;
      head.appendChild(element);
    }
    element.setAttribute('rel', 'canonical');
    element.setAttribute('href', url);
  }

  private readFilterDateFromStorage(): void {
    if (this.isBrowser) {
      const storedDate = moment(
        sessionStorage.getItem('filterDate'),
        dateSessionStorageFormat,
      )
        .utc()
        .startOf('day');
      if (storedDate.isValid()) {
        this.availableOn = storedDate;
      } else {
        const dateParam = this.route.snapshot.queryParamMap.get('date');
        if (dateParam) {
          this.availableOn = moment(dateParam, dateSessionStorageFormat)
            .utc()
            .startOf('day');
        }
      }

      const termStartDate = moment(
        sessionStorage.getItem('filterDateRangeStart'),
        dateSessionStorageFormat,
      )
        .utc()
        .startOf('day');
      const termEndDate = moment(
        sessionStorage.getItem('filterDateRangeEnd'),
        dateSessionStorageFormat,
      )
        .utc()
        .startOf('day');
      if (termStartDate.isValid()) {
        this.availableFrom = termStartDate;
      }
      if (termEndDate.isValid()) {
        this.availableTo = termEndDate;
      }
    }
  }

  private removeTransferState() {
    if (this.isBrowser) {
      this.state.remove(CHARTER_BUYFLOW_WATER_BODIES_KEY);
    }
  }

  private decreaseBoundsPrecision(boundsAndZoom: MapBoundsAndZoom): void {
    boundsAndZoom.mapBounds.southWestLat = decreaseLatLongPrecision(
      boundsAndZoom.mapBounds.southWestLat,
    );
    boundsAndZoom.mapBounds.southWestLng = decreaseLatLongPrecision(
      boundsAndZoom.mapBounds.southWestLng,
    );
    boundsAndZoom.mapBounds.northEastLat = decreaseLatLongPrecision(
      boundsAndZoom.mapBounds.northEastLat,
    );
    boundsAndZoom.mapBounds.northEastLng = decreaseLatLongPrecision(
      boundsAndZoom.mapBounds.northEastLng,
    );
    boundsAndZoom.center.latitude = decreaseLatLongPrecision(
      boundsAndZoom.center.latitude,
    );
    boundsAndZoom.center.longitude = decreaseLatLongPrecision(
      boundsAndZoom.center.longitude,
    );
  }

  private getBoundsAndZoomWhenNull(): MapBoundsAndZoom {
    let boundsAndZoom: MapBoundsAndZoom = {
      center: null,
      zoom: null,
      mapBounds: null,
    };

    if (
      this.waterBody &&
      this.route.snapshot.queryParamMap.get('fromSearchBar')
    ) {
      boundsAndZoom.center = {
        latitude: this.waterBody.latitude,
        longitude: this.waterBody.longitude,
      };
      boundsAndZoom.zoom = this.waterBody.zoom;
      boundsAndZoom.mapBounds = calculateMapBoundsFromCenterPoint(
        boundsAndZoom.center.latitude,
        boundsAndZoom.center.longitude,
        boundsAndZoom.zoom,
        this.isMobile,
      );
    } else if (this.readLatLongQueryParams()) {
      boundsAndZoom.center = this.readLatLongQueryParams().center;
      boundsAndZoom.zoom = this.readLatLongQueryParams().zoom;
      boundsAndZoom.mapBounds = calculateMapBoundsFromCenterPoint(
        boundsAndZoom.center.latitude,
        boundsAndZoom.center.longitude,
        boundsAndZoom.zoom,
        this.isMobile,
      );
    } else if (this.waterBody) {
      boundsAndZoom.center = {
        latitude: this.waterBody.latitude,
        longitude: this.waterBody.longitude,
      };
      boundsAndZoom.zoom = this.waterBody.zoom;
      boundsAndZoom.mapBounds = calculateMapBoundsFromCenterPoint(
        boundsAndZoom.center.latitude,
        boundsAndZoom.center.longitude,
        boundsAndZoom.zoom,
        this.isMobile,
      );
    } else if (this.location) {
      boundsAndZoom.center = {
        latitude: this.location.position.lat,
        longitude: this.location.position.lng,
      };
      boundsAndZoom.zoom = 11;
      boundsAndZoom.mapBounds = calculateMapBoundsFromCenterPoint(
        boundsAndZoom.center.latitude,
        boundsAndZoom.center.longitude,
        boundsAndZoom.zoom,
        this.isMobile,
      );
    }

    return boundsAndZoom;
  }

  private setFiltersFromQueryParams() {
    if (this.isMobile) {
      let priceMax = Number(this.route.snapshot.queryParamMap.get('priceMax'));
      if (priceMax > 0) {
        this.currentFilter.priceMax = priceMax;
      }
      let priceMin = Number(this.route.snapshot.queryParamMap.get('priceMin'));
      if (priceMin > 0) {
        this.currentFilter.priceMin = priceMin;
      }
      let passengers = Number(
        this.route.snapshot.queryParamMap.get('passengers'),
      );
      if (passengers > 0) {
        this.currentFilter.passengers = passengers;
      }
      let minLength = Number(
        this.route.snapshot.queryParamMap.get('boatLengthMin'),
      );
      if (minLength > 0) {
        this.currentFilter.boatLengthMin = minLength;
      }
      let maxLength = Number(
        this.route.snapshot.queryParamMap.get('boatLengthMax'),
      );
      if (maxLength > 0) {
        this.currentFilter.boatLengthMax = maxLength;
      }
      if (this.route.snapshot.queryParamMap.get('categories')) {
        this.currentFilter.categories = JSON.parse(
          this.route.snapshot.queryParamMap.get('categories'),
        ) as Category[];
      }

      const mobileFilters: MobileSortConfig = {
        sort: null,
        filters: this.currentFilter,
        clearClick: false,
      };

      setTimeout(() => {
        this.initiateMobileFiltering(mobileFilters);
      }, 1000);
    }
  }
}
